const isValidValue = (val) => {
  return val !== undefined;
};

const getValue = (val) => {
  if (val === undefined) {
    return '';
  }

  if (Array.isArray(val)) {
    return val.join(',');
  }

  return val;
};

const onlyStrings = (v) => typeof v === 'string';

const serialize = (obj) =>
  Object.entries(obj)
    .map(([key, val]) => (isValidValue(val) ? `${key}=${getValue(val)}` : null))
    .filter(onlyStrings)
    .join('&');

export default serialize;
